import Overlay from "ol/Overlay"
import i18next from "./i18next"
import map from "./map"

// 悬浮震度图标 / 海啸预警区域时,显示地点名提示框。
// 支持的图层:shindo(震度,要素带 properties.intensity + name)、
// tsunami_warning(海啸,要素带 properties.level + name)。

const TOOLTIP_LAYERS = ["shindo", "tsunami_warning"]

// 命中检测失败(如图标 CORS 问题导致 canvas 被污染)后只告警一次
let tooltipDisabled = false

const element = document.createElement("div")
element.className = "map-feature-tooltip"

const overlay = new Overlay({
  element,
  offset: [0, -14],
  positioning: "bottom-center",
  stopEvent: false,
})
map.addOverlay(overlay)

// 与 report_layers.intensityText 同格式,但此处独立引用以避免模块环
function intensityLabel(intensity) {
  return `${i18next.t("xml.report.intensity_text")}${i18next.t(`xml.report.intensity.${intensity}`)}`
}

function featureLabel(properties) {
  const { intensity, level, name } = properties
  if (level) return `${i18next.t(`xml.report.tsunami.${level}`)} ${name}`
  if (intensity && intensity !== "x") return `${intensityLabel(intensity)} ${name}`
  return name
}

export function hideFeatureTooltip() {
  overlay.setPosition(undefined)
  element.innerHTML = ""
  const target = map.getTargetElement()
  if (target) target.style.cursor = ""
}

function showFeatureTooltip(features, coordinate) {
  const lines = []
  const seen = new Set()
  for (const feature of features) {
    const { name } = feature.getProperties()
    if (!name) continue
    const label = featureLabel(feature.getProperties())
    const key = label
    if (seen.has(key)) continue
    seen.add(key)
    lines.push(`<div>${label}</div>`)
  }
  if (lines.length === 0) return hideFeatureTooltip()

  element.innerHTML = lines.join("")
  overlay.setPosition(coordinate)
  const target = map.getTargetElement()
  if (target) target.style.cursor = "pointer"
}

map.on("pointermove", (event) => {
  if (event.dragging) return hideFeatureTooltip()

  // 图层若含跨域加载失败的图标,命中检测读取 canvas 会抛 SecurityError;
  // 捕获后禁用悬浮提示,避免 pointermove 上反复报错
  let features
  try {
    features = map.getFeaturesAtPixel(event.pixel, {
      layerFilter: (layer) => TOOLTIP_LAYERS.includes(layer.get("name")),
      // 海啸海岸线较细,放宽命中范围
      hitTolerance: 6,
    })
  } catch (error) {
    if (!tooltipDisabled) {
      tooltipDisabled = true
      console.warn("地图悬浮提示已禁用:命中检测失败(CDN 图标需返回 CORS 头)", error)
    }
    return hideFeatureTooltip()
  }
  if (features.length > 0) {
    showFeatureTooltip(features, event.coordinate)
  } else {
    hideFeatureTooltip()
  }
})

// 指针离开地图区域时收起提示框
map.getViewport().addEventListener("pointerout", (event) => {
  if (!map.getViewport().contains(event.relatedTarget)) hideFeatureTooltip()
})
